import { UseCloudGameTransactions } from "./firebase.utils";

export async function checkForEarnedLevels(gameElements, playerData, gameData) {
  console.log('checking for earned levels');
  let earnedLevels = Object.values(gameElements)
    .filter(e =>
      e.type === 'level' &&
      e.opt_pointMinimum <= playerData.points &&
      (
        !playerData.levels ||
        !playerData.levels[e.id]
      )
    );
  console.log(earnedLevels);
  if (earnedLevels.length === 0) return;

  const res = await UseCloudGameTransactions(
    'awardEarnedLevels',
    {
      'playerId': playerData.playerId,
      'gameId': gameData.gameId
    }
  )
  console.log(res)
}